import {message} from "@/shared/message";

var FormGenerator = {
    workingItem : null,
    inputConfig: null,
    lstModel:[],
    formModel:{},
/*
    initConfig: function(url){
        $.get(url, function(config){
            this.inputConfig = JSON.parse(config);
        }, 'text');
    },
*/

    decodeHTML: function(html) {
        var txt = document.createElement('textarea');
        txt.innerHTML = html;
        return txt.value;
    },

    normalizeSQL: function (sql, variable) {
        let check = true;
        //console.log(sql);
        while(check) {
            check = false;
            let i1 = sql.indexOf("${");
            //console.log(i1);
            if (i1 >= 0) {
                let i2 = sql.indexOf("}", i1);
                let variabName = sql.substr(i1 + 2, i2 - i1 - 2);
                let value = variable[variabName];
                if(value == undefined){
                    value = "";
                }
                //console.log(variabName+"-"+value);
                sql = sql.replace("${" + variabName + "}", value);
                check = true;
            }
            //console.log(check);
            //console.log(sql);
        };
        return sql;
    },

    componentStartDrag: function(e){
        console.log("start");
        console.log(e.target);
        if(e.target.getAttribute("control") == "virtual"){
            FormGenerator.workingItem = {
                type:"insert",
                control:e.target.getAttribute("controlName")
            }
        } else {
            FormGenerator.workingItem = {
                type:"update",
                id:e.target.getAttribute("id"),
                control:e.target.getAttribute("controlName")
            }
        }
        console.log(FormGenerator.workingItem);
    },

    componentDragOver: function(e){
        e.preventDefault();
    },

    componentEndDrag: function(e){
        console.log("end");
        if(FormGenerator.workingItem.type == "insert") {
            FormGenerator.createDesignControl(FormGenerator.workingItem.control, e.clientX,e.clientY);
        } else {
            var designPanel = document.getElementById("design-panel");
            var div = document.getElementById(FormGenerator.workingItem.id);
            var posY = e.clientY;
            var workingId = null;
            var model = null;
            for(var i=0;i<FormGenerator.lstModel.length;i++){
                if(FormGenerator.lstModel[i].id == FormGenerator.workingItem.id){
                    workingId = i;
                    model = FormGenerator.lstModel[i];
                    FormGenerator.lstModel.splice(i,1);
                    break;
                }
            }
            var lstChild = designPanel.getElementsByClassName("designcontrol");
            var isUpdate =false;
            for(var i=0;i<lstChild.length;i++){
                var rect = lstChild[i].getBoundingClientRect();
                console.log(rect);
                if(rect.top > posY){
                    designPanel.insertBefore(div,lstChild[i]);
                    //
                    // swap model
                    //
                    FormGenerator.lstModel.splice(i,0,model);
                    isUpdate = true;
                    break;
                }
            }
            if(!isUpdate){
                FormGenerator.lstModel.push(model);
                designPanel.appendChild(div);
            }
        }
    },

    deleteComponent: function(e){
        var item = e.target;
        var id = item.parentNode.getAttribute("id");
        item.parentNode.parentNode.removeChild(item.parentNode);
        //
        // xoa model
        //
        for(var i=0;i<FormGenerator.lstModel.length;i++){
            if(FormGenerator.lstModel[i].id == id){
                FormGenerator.lstModel.splice(i,1);
                break;
            }
        }
    },

    createInputPanel : function() {
        //
        // render control panel
        //
        var panel = document.getElementById("ctrl-panel");
        panel.innerHTML = "";
        var designPanel = document.getElementById("design-panel");
        designPanel.innerHTML = "";
        designPanel.onclick = this.showFormProperties;
        var propertiesPanel = document.getElementById("properties-panel");
        propertiesPanel.innerHTML = "";
        designPanel.ondrop = this.componentEndDrag;
        designPanel.ondragover = this.componentDragOver;
        designPanel.ondragend = this.componentEndDrag;
        for(var i=0;i<this.inputConfig.types.length;i++){
            if(this.inputConfig.types[i].abstract != true){
                var component = document.createElement("div");
                component.setAttribute("control","virtual");
                component.setAttribute("controlName",this.inputConfig.types[i].name);
                component.setAttribute("class","Control");
                component.setAttribute("draggable","true");
                var img = document.createElement("img");
                img.setAttribute("draggable","false");
                img.src= this.inputConfig.types[i].img;
                var labelInp = document.createElement("label");
                labelInp.innerHTML = this.inputConfig.types[i].name;
                component.appendChild(img);
                component.appendChild(labelInp);
                component.ondragstart = this.componentStartDrag;
                panel.appendChild(component);
            }
        }
    },

    clearPropertyPanel: function(){
        var propertiesPanel = document.getElementById("properties-panel");
        propertiesPanel.innerHTML = "";
    },

    getAllProperties: function(controlArr){
        var properties = [];
        if(controlArr.length>0){
            for(var i=0;i<controlArr.length;i++){
                for(var j=0;j<FormGenerator.inputConfig.types.length;j++){
                    if(FormGenerator.inputConfig.types[j].name == controlArr[i]){
                        if(FormGenerator.inputConfig.types[j].superClass != undefined && FormGenerator.inputConfig.types[j].superClass != null){
                            var parentProperties = FormGenerator.getAllProperties(FormGenerator.inputConfig.types[j].superClass);
                            if(parentProperties != null && parentProperties.length>0) {
                                properties = properties.concat(parentProperties);
                            }
                        }
                        for(var h=0;h< FormGenerator.inputConfig.types[j].properties.length;h++) {
                            properties.push(FormGenerator.inputConfig.types[j].properties[h]);
                        }
                    }
                }
            }
        }
        return properties;
    },

    cloneObject: function(obj){
        return JSON.parse(JSON.stringify(obj));
    },

    createControl: function(model ,isDesign) {
        if(isDesign == undefined || isDesign == null){
            isDesign = true;
        }
        var div = document.createElement("div");
        div.setAttribute("id",model.id);
        div.setAttribute("class","designcontrol");
        if(isDesign) {
            div.setAttribute("draggable", "true");
        }
        div.setAttribute("control","true");
        div.setAttribute("controlName",model.name);
        if(isDesign) {
            var deleteItem = document.createElement("div");
            deleteItem.setAttribute("class", "deleteItem");
            deleteItem.onclick = this.deleteComponent;
            div.appendChild(deleteItem);
            div.ondragstart = this.componentStartDrag;
            div.onclick = this.showControlProperties;
        }

        var labelInp;
        if(model.name == "Checkbox"){
            labelInp = document.createElement("label");
            labelInp.setAttribute("class","labelInp");
            labelInp.innerText="labelInp";
            var ctrl = document.createElement("div");
            ctrl.setAttribute("class","containerInp");
            ctrl.innerHTML = model.template;
            ctrl.appendChild(labelInp);
            div.appendChild(ctrl);
            //div.appendChild(labelInp);
        } else {
            labelInp = document.createElement("div");
            div.appendChild(labelInp);
            labelInp.setAttribute("class","labelInp");
            labelInp.innerText="labelInp";
            var ctrl = document.createElement("div");
            ctrl.setAttribute("class","containerInp");
            ctrl.innerHTML = model.template;
            div.appendChild(ctrl);
        }
        if(model.script != undefined && model.script != null && model.script != ""){
            var script = document.createElement("script");
            script.type = "text/javascript";
            var scriptText = model.script;
            for(var i=0;i<model.properties.length;i++){
                scriptText = scriptText.replace(new RegExp('\\$\\{'+model.properties[i].name+"\\}", 'g'), model.properties[i].value);
            }
            script.innerText = scriptText;
            //
            //
            //
            div.appendChild(script);
        }

        for(var i=0;i<model.properties.length;i++) {
            var propertyName = model.properties[i].name;
            var propertyValue = model.properties[i].value;
            if(propertyValue == undefined || propertyValue == null){
                continue;
            }
            if (propertyName == "label") {
                labelInp.innerText = model.properties[i].value;
            } else if (propertyName == "options") {
                var options = propertyValue.split(",");
                if (model.name == "SelectBox") {
                    var input = div.getElementsByTagName("select")[0];
                    input.innerHTML = "";
                    for (var j = 0; j < options.length; j++) {
                        var option = document.createElement("option");
                        option.innerText = options[j];
                        option.setAttribute("value", options[j]);
                        input.appendChild(option);
                    }
                } else if (model.name == "Radio") {
                    var containerInp = div.getElementsByClassName("containerInp")[0];
                    containerInp.innerHTML = "";
                    var name = "";
                    for (var j = 0; j < model.properties.length; j++) {
                        if (model.properties[j].name == "name") {
                            name = model.properties[j].value;
                        }
                    }
                    for (var j = 0; j < options.length; j++) {
                        var option = document.createElement("input");
                        option.setAttribute("type", "radio");
                        option.setAttribute("value", options[j]);
                        option.setAttribute("name", name);
                        containerInp.appendChild(option);
                        var labelInp = document.createElement("label");
                        labelInp.innerText = options[j];
                        containerInp.appendChild(labelInp);
                        var newline = document.createElement("br");
                        containerInp.appendChild(newline);
                    }
                }
            } else {
                var inputs;
                if (model.name == "Textarea") {
                    inputs = ctrl.getElementsByTagName("textarea");
                } else if (model.name == "SelectBox") {
                    inputs = ctrl.getElementsByTagName("select");
                } else {
                    inputs = ctrl.getElementsByTagName("input");
                }
                for (var j = 0; j < inputs.length; j++) {
                    inputs[j].setAttribute(propertyName, propertyValue);
                }
            }
        }
        return div;
    },

    loadDesign:function(config){
        //
        // clear old design
        //
        var designPanel = document.getElementById("design-panel");
        designPanel.innerHTML = "";
        FormGenerator.clearPropertyPanel();
        //
        //
        //
        if(config == null || config == ""){
            FormGenerator.lstModel = [];
            //console.log(FormGenerator.inputConfig.types);
            FormGenerator.formModel = FormGenerator.cloneObject(FormGenerator.inputConfig.types[0]);
            FormGenerator.formModel.id = "design-panel";
            return;
        } else {
            var formConfig = JSON.parse(config);
            if(formConfig.form == undefined){
                FormGenerator.lstModel = formConfig;
                FormGenerator.formModel = FormGenerator.cloneObject(FormGenerator.inputConfig.types[0]);
                FormGenerator.formModel.id = "design-panel";
            } else {
                FormGenerator.lstModel = formConfig.control;
                FormGenerator.formModel = formConfig.form;
            }
            //console.log(lstModel);
            for (var i = 0; i < FormGenerator.lstModel.length; i++) {
                var ctrl = this.createControl(FormGenerator.lstModel[i]);
                designPanel.appendChild(ctrl);
            }
        }
    },

    loadFormModel:function(config, formId){
        let formConfig = {} ;
        FormGenerator.formModel = null;
        FormGenerator.lstModel = [];
        try {
            formConfig = JSON.parse(config);
        } catch(e){
            console.log(e);
        }

        if(formConfig.form == undefined) {
            FormGenerator.lstModel = formConfig;
        } else {
            FormGenerator.formModel = formConfig.form;
            FormGenerator.lstModel = formConfig.control;
        }
    },

    modelToInputProperties: function(){
        let lstInput = [];
        for(let i=0;i<this.lstModel.length;i++){
            let inp = {
                type:this.lstModel[i].name
            };
            let properties = {};
            for(let j=0;j<this.lstModel[i].properties.length;j++){
                if(this.lstModel[i].properties[j].value != undefined && this.lstModel[i].properties[j].value != null){
                    if(this.lstModel[i].properties[j].name == "options"){
                        properties["items"] = this.lstModel[i].properties[j].value.split(",");
                    } else {
                        properties[this.lstModel[i].properties[j].name] = this.lstModel[i].properties[j].value;
                    }
                }
            }
            inp.properties =properties;
            lstInput.push(inp);
        }
        return lstInput;
    },

    toFormProperties:function(){
        let properties = {};
        if(FormGenerator.formModel == undefined || FormGenerator.formModel == null){
            return properties;
        }
        if(FormGenerator.formModel.properties == undefined || FormGenerator.formModel.properties == null){
            return properties;
        }
        for(let j=0;j<FormGenerator.formModel.properties.length;j++){
            if(FormGenerator.formModel.properties[j].value != undefined && FormGenerator.formModel.properties[j].value != null){
                if(FormGenerator.formModel.properties[j].name == "options"){
                    properties["items"] = FormGenerator.formModel.properties[j].value.split(",");
                } else {
                    properties[FormGenerator.formModel.properties[j].name] = FormGenerator.formModel.properties[j].value;
                }
            }
        }
        //console.log(properties);
        if(properties["tabs"] != undefined && properties["tabs"] != null && properties["tabs"] != ""){
            let keys = properties["tabs"].split(",");
            properties["tabs"] = [];
            for(let i=0;i<keys.length;i++){
                let tabItem = {
                    name:keys[i],
                    key:i+"_"+(new Date()).getTime()
                }
                properties["tabs"].push(tabItem);
                console.log(properties["tabs"]);
            }
            //properties["tabs"] = properties["tabs"].split(",");
        }
        return properties;
    },

    loadForm:function(config, formId){
        var lstModel;
        try {
            lstModel = JSON.parse(config);
        } catch (e){
            console.log(e);
        }
        FormGenerator.lstModel = lstModel;

        var designPanel = document.getElementById(formId);
        designPanel.innerHTML = "";
        for(var i=0;i<lstModel.length;i++){
            var ctrl = this.createControl(lstModel[i],false);
            designPanel.appendChild(ctrl);
        }
    },

    loadInputData:function(lstData){
        console.log(lstData);
        for (var key in lstData) {
            var name = key;
            var value = lstData[key];
            var items = document.getElementsByName(name);
            if (items.length > 0) {
                for (var j = 0; j < items.length; j++) {
                    if (items[j].tagName.toLowerCase() == "input") {
                        var ctrlType = items[j].getAttribute("type").toLowerCase();
                        if (ctrlType == "radio") {
                            if (items[j].value == value) {
                                items[j].checked = true;
                            }
                        } else if (ctrlType == "checkbox") {
                            if (items[j].value == value) {
                                items[j].checked = true;
                            }
                        } else {
                            items[j].value = value;
                        }
                    } else {
                        items[j].value = value;
                    }
                }
            }
        }
    },

    loadView:function(config, data, formId){
        var lstModel = JSON.parse(config);
        FormGenerator.lstModel = lstModel;
        var designPanel = document.getElementById(id);
        designPanel.innerHTML = "";
        console.log(lstModel);
        for(var i=0;i<lstModel.length;i++){
            var ctrl = this.createControl(lstModel[i]);
            designPanel.appendChild(ctrl);
        }
    },

    updatePropertyOfModel: function(){
        var value = this.value;
        var controlId = this.getAttribute("controlid");
        var propertyName = this.getAttribute("propertyname");
        console.log(controlId+"-"+propertyName);
        if(controlId == "design-panel"){
            for (var i = 0; i < FormGenerator.formModel.properties.length; i++) {
                if (FormGenerator.formModel.properties[i].name == propertyName) {
                    FormGenerator.formModel.properties[i].value = value;
                    break;
                }
            }

        } else {
            //
            // update model
            //
            var model = FormGenerator.getModelById(controlId);
            for (var i = 0; i < model.properties.length; i++) {
                if (model.properties[i].name == propertyName) {
                    model.properties[i].value = value;
                    break;
                }
            }
            //
            // update ui
            //
            var item = document.getElementById(controlId);
            var newitem = FormGenerator.createControl(model);
            var parent = item.parentNode;
            parent.insertBefore(newitem, item);
            parent.removeChild(item);
        }

    },

    createDesignControl:function(name, posX, posY){
        var ctrlId = name+"_"+(new Date()).getTime();
        var designPanel = document.getElementById("design-panel");
        var ctrl;
        var model;
        for(var i=0;i<this.inputConfig.types.length;i++){
            if(this.inputConfig.types[i].name == name){
                model = FormGenerator.cloneObject( this.inputConfig.types[i]);
                break;
            }
        }
        //
        // insert all model of superclass
        //
        var parentProperties = FormGenerator.getAllProperties(model.superClass);
        if(parentProperties != null && parentProperties.length>0) {
            model.properties = parentProperties.concat(model.properties);
        }
        model = FormGenerator.cloneObject(model);
        model.id = ctrlId;
        //
        // generate
        //
        var div = this.createControl(model);

        //console.log(model);
        var lstChild = designPanel.getElementsByClassName("designcontrol");
        console.log(lstChild);
        var isInsert = false;
        console.log(posX+"-"+posY);
        for(var i=0;i<lstChild.length;i++){
            var rect = lstChild[i].getBoundingClientRect();
            console.log(rect);
            if(rect.top > posY){
                designPanel.insertBefore(div,lstChild[i]);
                console.log("insert at: "+i);
                console.log(this.lstModel);
                this.lstModel.splice(i,0,model);
                console.log(this.lstModel);
                isInsert = true;
                break;
            }
        }
        if(!isInsert){
            designPanel.appendChild(div);
            this.lstModel.push(model);
            this.createPropertiesPanel(model);
        }
    },

    getModelById:function(id){
        console.log("id:"+id);
        for(var i=0;i<FormGenerator.lstModel.length;i++){
            if(FormGenerator.lstModel[i].id == id){
                return FormGenerator.lstModel[i];
                break;
            }
        }
        return null;
    },

    showFormProperties: function(e){
        console.log(FormGenerator.formModel);
        FormGenerator.createPropertiesPanel(FormGenerator.formModel);
    },

    showControlProperties: function(e){
        e.stopPropagation();
        let model = FormGenerator.getModelById(this.getAttribute("id"));
        FormGenerator.createPropertiesPanel(model);
    },

    createPropertiesPanel: function(model){
        var propertiesPanel = document.getElementById("properties-panel");
        propertiesPanel.innerHTML = "";
        console.log(model);
        for(var i=0;i<model.properties.length;i++){
            var property = model.properties[i];
            var div = document.createElement("div");
            div.setAttribute("class","property");
            propertiesPanel.appendChild(div);
            var labelInp = document.createElement("div");
            labelInp.setAttribute("class","labelInp");
            labelInp.innerText = property.name;
            div.appendChild(labelInp);
            var ctrl = null;
            if (model.properties[i].type == "string" || model.properties[i].type == "integer") {
                ctrl = document.createElement("input");
                if (model.properties[i].type == "integer") {
                    ctrl.setAttribute("type", "number");
                } else {
                    ctrl.setAttribute("type", "textbox");
                }
                ctrl.onchange = this.updatePropertyOfModel;
            } else if (model.properties[i].type == "boolean") {
                ctrl = document.createElement("select");
                var tO = document.createElement("option");
                tO.setAttribute("value", "true");
                tO.innerHTML = "True";
                ctrl.appendChild(tO);
                var fO = document.createElement("option");
                fO.setAttribute("value", "false");
                fO.innerHTML = "False";
                ctrl.appendChild(fO);
                ctrl.onchange = this.updatePropertyOfModel;
            } else if (model.properties[i].type == "select") {
                ctrl = document.createElement("select");
                let options = model.properties[i].option.split(",");
                for(let j=0;j<options.length;j++) {
                    let tO = document.createElement("option");
                    tO.setAttribute("value", options[j]);
                    tO.innerHTML = options[j];
                    ctrl.appendChild(tO);
                }
                ctrl.onchange = this.updatePropertyOfModel;

            } else {
                ctrl = document.createElement("input");
                ctrl.onchange = this.updatePropertyOfModel;
            }

            console.log(model.properties[i].name+":"+model.properties[i].value);
            if (model.properties[i].value == undefined) {
                ctrl.value ="";
            } else {
                ctrl.value = model.properties[i].value;
            }
            if(model.properties[i].hint != undefined && model.properties[i].hint != null){
                ctrl.setAttribute("title",model.properties[i].hint);
            }
            ctrl.setAttribute("id",model.id+"_"+model.properties[i].name);
            ctrl.setAttribute("controlid",model.id);
            ctrl.setAttribute("propertyname",model.properties[i].name);
            if(ctrl != null) {
                div.appendChild(ctrl);
            }
        }
    },

    validate: function(){
        var nameArr = [];
        for(var i=0;i<FormGenerator.lstModel.length;i++){
            var name = null;
            for(var j=0;j<FormGenerator.lstModel[i].properties.length;j++){
                if(FormGenerator.lstModel[i].properties[j].name == "name"){
                    name = FormGenerator.lstModel[i].properties[j].value;
                    break;
                }
            }
            if(name == undefined || name == null ||  name.trim() == ""){
                message.error("all control name is required");
                return false;
            }
            name = name.toLowerCase();
            if(nameArr.includes(name)){
                message.error("all control name must be unique");
                return false;
            }
            nameArr.push(name);
        }
        return true;
    },

    exportToString: function(){
        if(FormGenerator.validate()) {
            return JSON.stringify({
                form:FormGenerator.formModel,
                control: FormGenerator.lstModel
            });
        } else {
            return "error";
        }
    },

    convertFormToJSON: function(id){
        let form = document.getElementById(id);
        console.log(form);
        let inputs = form.getElementsByTagName("input");
        let textareas = form.getElementsByTagName("textarea");
        let selects = form.getElementsByTagName("select");
        let ob = {};
        console.log(inputs);
        console.log(textareas);
        console.log(selects);
        for(let i=0;i<inputs.length;i++) {
            let item = inputs[i];
            ob[item.name] = item.value;
        }
        for(let i=0;i<selects.length;i++) {
            let item = selects[i];
            ob[item.name] = item.value;
        }
        for(let i=0;i<textareas.length;i++) {
            let item = textareas[i];
            ob[item.name] = item.value;
        }
        console.log('--- form values ---');
        console.log(ob);
        return ob;
    }
};

export default FormGenerator;